export const KINERJA_PS_PERENCANAAN_PRAKTIK_KINERJA_DRAFT_STORAGE_KEY =
  'kinerja-ps-perencanaan-praktik-kinerja-draft'
